import React, { PropTypes, Component } from 'react';
import classNames from 'classnames';

const css = oxygenCss({
  container: {
    position: 'relative',
    boxSizing: 'border-box'
  },
  mediaHolder: {
    width: '100%',
    paddingBottom: `${9 / 16 * 100}%`,
    position: 'relative'
  },
  media: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  element: {
    maxHeight: '100%',
    alignSelf: 'center'
  },
  cardImage: {
    width: '100%'
  }
});

export default class CardImage extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    mediaClassName: PropTypes.string
  };

  render() {
    const { className, children, mediaClassName, ...other } = this.props;
    const child = React.Children.only(children);
    return (
      <div className={classNames(className, css.container)} {...other}>
        <div className={css.mediaHolder}>
          <div className={classNames(mediaClassName, css.media)}>
            {React.cloneElement(child, {
              className: classNames(child.props.className, css.element)
            })}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/AspectRatioContainer.js